(function(){
  'use strict';

  function fmtMoney(cents, format){
    var amt = (cents/100).toFixed(2);
    if(!format) return '$' + amt;
    return format.replace(/\{\{\s*amount\s*\}\}/g, amt)
                 .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents/100).toString())
                 .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amt.replace('.', ','));
  }

  function initLede(scope){
    scope.querySelectorAll('[data-lede]').forEach(function(lede){
      if(lede.dataset.hwLedeInit) return;
      lede.dataset.hwLedeInit = '1';
      var text = lede.querySelector('[data-lede-text]');
      var btn = lede.querySelector('[data-lede-toggle]');
      if(!text || !btn) return;
      var check = function(){
        if(text.scrollHeight > text.clientHeight + 1){
          btn.hidden = false;
        } else {
          btn.hidden = true;
        }
      };
      if(document.fonts && document.fonts.ready){
        document.fonts.ready.then(check);
      }
      check();
      window.addEventListener('resize', check);
      btn.addEventListener('click', function(){
        var expanded = lede.classList.toggle('is-expanded');
        btn.textContent = expanded ? 'Show less' : 'Read more';
      });
    });
  }

  function initGallery(section){
    var gallery = section.querySelector('[data-gallery]');
    if(!gallery || gallery.dataset.hwGalleryInit) return;
    gallery.dataset.hwGalleryInit = '1';
    var thumbs = gallery.querySelectorAll('[data-thumb-index]');
    var slides = gallery.querySelectorAll('[data-slide-index]');
    if(thumbs.length === 0 || slides.length === 0) return;

    function setActiveThumb(idx){
      thumbs.forEach(function(t){
        var match = parseInt(t.dataset.thumbIndex, 10) === idx;
        t.classList.toggle('is-active', match);
        t.setAttribute('aria-selected', match ? 'true' : 'false');
      });
    }

    thumbs.forEach(function(t){
      t.addEventListener('click', function(){
        var idx = parseInt(t.dataset.thumbIndex, 10) || 0;
        setActiveThumb(idx);
        var target = gallery.querySelector('[data-slide-index="'+idx+'"]');
        if(target){
          try { target.scrollIntoView({behavior:'smooth', inline:'start', block:'nearest'}); }
          catch(_){ target.scrollIntoView(); }
        }
      });
    });

    var viewer = gallery.querySelector('[data-gallery-viewer]');
    if(viewer && 'IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting && e.intersectionRatio > 0.6){
            var idx = parseInt(e.target.dataset.slideIndex, 10) || 0;
            setActiveThumb(idx);
          }
        });
      }, {root: viewer, threshold: [0.6]});
      slides.forEach(function(s){ io.observe(s); });
    }
  }

  function init(box){
    if(!box || box.dataset.hwInit) return;
    box.dataset.hwInit = '1';

    var section = box.closest('[data-buybox-section]') || box.parentElement;
    if(section) initGallery(section);
    initLede(box);

    var basePrice = parseInt(box.dataset.basePrice, 10) || 0;
    var compare = parseInt(box.dataset.compare, 10) || 0;
    var fmt = box.dataset.moneyFormat || '${{amount}}';

    var displayPriceEl = box.querySelector('[data-display-price]');
    var buttonPriceEl = box.querySelector('[data-button-price]');
    var displayCompareEl = box.querySelector('[data-display-compare]');
    var displaySaveEl = box.querySelector('[data-display-save]');
    var packGroup = box.querySelector('[data-pack-group]');
    var planGroup = box.querySelector('[data-plan-group]');
    var nudge = box.querySelector('[data-nudge]');
    var nudgeCta = box.querySelector('[data-nudge-cta]');
    var sticky = document.querySelector('[data-sticky-atc]');
    var stickyPriceEl = sticky ? sticky.querySelector('[data-sticky-price]') : null;

    var form = box.querySelector('[data-buybox-form]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;

    var hasInteracted = false;

    function getPackInfo(){
      var fallback = {variantId:'', price: basePrice, compare: compare, bottles: 1};
      if(!packGroup) return fallback;
      var checked = packGroup.querySelector('input[type=radio]:checked');
      if(!checked) return fallback;
      return {
        variantId: checked.dataset.variantId || '',
        price: parseInt(checked.dataset.variantPrice, 10) || basePrice,
        compare: parseInt(checked.dataset.variantCompare, 10) || 0,
        bottles: parseInt(checked.dataset.bottles, 10) || 1
      };
    }
    function getPlanDiscount(){
      if(!planGroup) return 0;
      var checked = planGroup.querySelector('input[type=radio]:checked');
      if(!checked) return 0;
      return parseInt(checked.dataset.planDiscount, 10) || 0;
    }

    function updatePackCards(){
      box.querySelectorAll('[data-pack-display]').forEach(function(el){
        var n = parseInt(el.dataset.packDisplay, 10) || 1;
        var radio = box.querySelector('input[data-bottles="'+n+'"]');
        var p = radio ? parseInt(radio.dataset.variantPrice, 10) || 0 : 0;
        el.textContent = fmtMoney(p, fmt);
      });
    }

    function updateNudge(){
      if(!nudge) return;
      var pack = getPackInfo();
      nudge.hidden = (pack.bottles !== 1);
    }

    function updateVariantId(){
      var pack = getPackInfo();
      if(idInput && pack.variantId){
        idInput.value = pack.variantId;
      }
    }

    function recalc(){
      var pack = getPackInfo();
      var planDiscount = getPlanDiscount();
      var unit = Math.round(pack.price * (1 - planDiscount/100));
      var totalStr = fmtMoney(unit, fmt);

      if(hasInteracted){
        if(displayPriceEl) displayPriceEl.textContent = totalStr;
        if(buttonPriceEl) buttonPriceEl.textContent = totalStr;
        if(stickyPriceEl) stickyPriceEl.textContent = totalStr;
        if(displayCompareEl){
          if(pack.compare > 0 && pack.compare > pack.price){
            displayCompareEl.textContent = fmtMoney(pack.compare, fmt);
            displayCompareEl.hidden = false;
          } else {
            displayCompareEl.hidden = true;
          }
        }
        if(displaySaveEl){
          if(pack.compare > pack.price){
            var pct = Math.round((pack.compare - pack.price) * 100 / pack.compare);
            if(pct > 0){
              displaySaveEl.textContent = 'Save ' + pct + '%';
              displaySaveEl.hidden = false;
            } else {
              displaySaveEl.hidden = true;
            }
          } else {
            displaySaveEl.hidden = true;
          }
        }
      }

      updateVariantId();
      updatePackCards();
      updateNudge();
    }

    if(packGroup) packGroup.addEventListener('change', function(){ hasInteracted = true; recalc(); });
    if(planGroup) planGroup.addEventListener('change', function(){ hasInteracted = true; recalc(); });

    if(nudgeCta){
      nudgeCta.addEventListener('click', function(){
        var bump = box.querySelector('input[data-bottles="3"]') || box.querySelector('input[data-bottles="6"]');
        if(bump){
          bump.checked = true;
          bump.dispatchEvent(new Event('change', {bubbles:true}));
        }
      });
    }

    recalc();

    var atc = box.querySelector('[data-atc-button]');
    if(atc && sticky && 'IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){
            sticky.classList.remove('is-visible');
          } else if(e.boundingClientRect.top < 0){
            sticky.classList.add('is-visible');
          } else {
            sticky.classList.remove('is-visible');
          }
        });
      }, {threshold: 0});
      io.observe(atc);
    }

    if(sticky){
      var stickyBtn = sticky.querySelector('[data-sticky-btn]');
      var formId = sticky.dataset.formTarget;
      if(stickyBtn && formId){
        stickyBtn.addEventListener('click', function(){
          var form = document.getElementById(formId);
          if(form){
            var realBtn = form.querySelector('[data-atc-button]');
            if(realBtn) realBtn.click();
            else form.submit();
          }
        });
      }
    }
  }

  function start(){
    document.querySelectorAll('.hw-pdp__buybox').forEach(init);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();
